import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import MultiStoryRowElements from './multi_story_row/multi_story_row_elements';
import OpenerImage from '../common/opener_image';
// import { propTypes as rowPropTypes } from './row';
import { sendAnalyticsEvent } from '../../utils/analytics';
import {get} from 'lodash';

const RECOMMENDED_SHOWS_MODULE_TYPE = 'recommended-shows';

export default class MultiStoryRow extends Component {
  handleClick = () => sendAnalyticsEvent(
    'Aggregation',
    'Click',
    `Card ${this.props.cards[0].cardID}`
  );

  episodeCount = () =>
    <div className="meta">
      <RosettaFormattedMessage parentFilename={__filename}
        id="episode_count"
        description="Number of episodes listed on a show's opener image"
        defaultMessage="{episode_count} Episodes"
        values={{ episode_count: this.props.cards[0].episode_count }}
      />
    </div>;

  render() {
    const {
      dataAttributes,
      cards: [{
        cardID,
        display_name,
        opener_images,
        entries
      }],
      moduleType,
      type
    } = this.props;
    const isRecommendedShowsRow = moduleType === RECOMMENDED_SHOWS_MODULE_TYPE;
    return (
      <div className="row multi-story" {...dataAttributes}>
        <div className="series-container">
          <Link to={get(entries, '[0].path')} onClick={this.handleClick}>
            <OpenerImage opener_images={opener_images} rowType={type} />
            {isRecommendedShowsRow && this.episodeCount()}
          </Link>
          <MultiStoryRowElements
            cardID={cardID}
            display_name={display_name}
            entries={entries}
            isRecommendedShowsRow={isRecommendedShowsRow}
          />
        </div>
      </div>
    );
  }
}

// MultiStoryRow.propTypes = Object.assign({}, rowPropTypes, {
//   dataAttributes: PropTypes.object.isRequired,
//   cards: PropTypes.arrayOf(PropTypes.shape({
//     cardID: PropTypes.number.isRequired,
//     display_name: PropTypes.string.isRequired,
//     entries: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
//     episode_count: PropTypes.number,
//     opener_images: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
//   })).isRequired,
//   moduleType: PropTypes.string.isRequired,
//   type: PropTypes.string.isRequired
// });
